import { take } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { VisitorsAreaService } from '../services/visitors-area.service';

export function companyType(visitorsAreaService: VisitorsAreaService): () => Promise<void> {
  return async (): Promise<void> => {
    return new Promise(resolve => {
      visitorsAreaService
        .getConfig(true, true)
        .pipe(
          take(1),
          map(c => c?.mainComponent ?? ''),
          tap(type => localStorage.setItem('GA_TYPE', type || 'apartments')),
        )
        .subscribe(() => resolve());
    });
  };
}
